<template>
  <div>
    <Row class="table-toolbar">
      <div class="table-toolbar-left">
        <Button type="primary" @click="onAddBtnClick" v-if="showAddBtn">
          <Icon type="ios-add" color="white" style="margin-right: 5px;"></Icon>新增</Button>
        <slot name="toolBarAction"></slot>
      </div>
      <div class="table-toolbar-right">
        <Form class="form-inline" role="form" :label-width="40" inline @submit.native.prevent >
          <slot name="toolbarSearch"></slot>
          <Input @on-enter="onSearchBtnClick" v-if="defaultSearchBox" v-model="searchKey" clearable :placeholder="defaultSearchPlaceholder" style="width: 150px;">
          <Icon v-if="!defaultSearchBtn" type="ios-search" slot="suffix"  />
          </Input>
          <Button v-if="defaultSearchBtn" class="search-btn" type="primary" @click="onSearchBtnClick"><Icon type="ios-search"/>&nbsp;&nbsp;搜索</Button>
        </Form>
      </div>
    </Row>
    <Row>
      <Table
        ref="dragable"
        :row-key="rowKey"
        :data="insideTableData"
        :columns="insideColumns"
        :stripe="stripe"
        :border="border"
        :show-header="showHeader"
        :width="width"
        :height="height"
        :loading="loading"
        :disabled-hover="disabledHover"
        :highlight-row="highlightRow"
        :span-method="spanMethod"
        :row-class-name="rowClassName"
        :size="size"
        :no-data-text="noDataText"
        :load-data="loadData"
        :no-filtered-data-text="noFilteredDataText"
        @on-current-change="onCurrentChange"
        @on-select="onSelect"
        @on-select-cancel="onSelectCancel"
        @on-select-all="onSelectAll"
        @on-selection-change="onSelectionChange"
        @on-sort-change="onSortChange"
        @on-filter-change="onFilterChange"
        @on-row-click="onRowClick"
        @on-row-dblclick="onRowDblclick"
        @on-expand="onExpand"
      >
        <slot name="table-content" slot-scope="{row, column, index}" :row="row" :column="column" :index="index"></slot>
      </Table>
      <div v-if=" !(hidePageForOne&&allPages < 2)" style="padding: 10px;overflow: hidden;width: 100%;">
        <div style="float: right;">
          <Page :total="insideTotalCount"
                :current="currentPage"
                :pageSize="pageSize"
                :show-sizer="showSizer"
                :show-elevator="showElevator"
                :page-size-opts = "pageSizeOpts"
                @on-change="changePage($event)"
                @on-page-size-change="changePageSize($event)"
                :show-total="showTotal"
          >
          </Page>
        </div>
      </div>
    </Row>
    <slot name="table-bottom"></slot>
    <dxy-modal v-model="addViewMode"
               :title= "addViewTitle"
               :okAutoClose="false"
               :width="dialogWidth"
               :loading="addFormLoading"
               @on-ok="onAddViewBtnOk"
               @on-cancel="onAddViewBtnCancel"
               @on-add-item-start="onAddItemStart($event)"
               @on-save-item-success="saveAddItemSuccess($event)"
    >
      <slot name="addViewContent" :clickOkBtn="addViewClickOk">
        <p>请添加您的视图页面</p>
      </slot>
    </dxy-modal>
    <Modal></Modal>
    <dxy-modal
      v-model="editViewMode"
      :title= "editViewTitle"
      :width="dialogWidth"
      :okAutoClose="false"
      :loading="editFormLoading"
      @on-ok="onEditViewBtnOk"
      @on-cancel="onEditViewBtnCancel"
      @on-edit-item-start="onEditItemStart($event)"
      @on-save-item-success="saveEditItemSuccess($event)"
    >
      <slot name="editViewContent">
        <p>请添加您的视图页面</p>
      </slot>
    </dxy-modal>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import TablesEdit from './edit.vue'
import handleBtns from './../common/handle-btns'
import DxyModal from '../dxy-modal/dxy-modal'
import { deepCopy } from './../../utils/assist.js'
export default {
  name: 'base-table',
  components: { DxyModal },
  data () {
    return {
      addFormLoading: false,
      editFormLoading: false,
      // 表格内部列数据
      insideColumns: [],
      // 表格行数据
      insideTableData: [],
      insideTotalCount: 0,
      cacheTableData: [],
      // 列支持编辑的辅助条件
      edittingCellId: '',
      // 编辑列发生变化后文本
      edittingText: '',
      // 编辑列原始文本，用于判断列的内容是否真实发生变化
      originalEdittingText: '',
      // 分页当前页码
      currentPage: 1,
      addViewClickOk: 0,
      pageSize: this.defaultPageSize,
      pageSizeList: [10, 20, 30, 40],
      addViewMode: false,
      editViewMode: false,
      searchKey: ''
    }
  },
  computed: {
    allPages () {
      const allPage = Math.ceil(this.insideTotalCount / this.pageSize)
      return (allPage === 0) ? 1 : allPage
    }
  },
  props: {
    rowKey: {
      type: [Boolean, String],
      default: false
    },
    rowData: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      type: Array,
      default () {
        return []
      }
    },
    clientSidePage: {
      type: Boolean,
      default: false
    },
    loadData: {
      type: Function,
      default: () => {}
    },
    spanMethod: {
      type: Function,
      default: () => {}
    },
    defaultBtnPermission: {
      type: Function,
      default () {
        return () => {
          return true
        }
      }
    },
    totalCount: {
      type: Number,
      default: 0
    },
    pageIndex: {
      type: Number
    },
    defaultPageSize: {
      type: Number,
      default: 20
    },
    showAddBtn: {
      type: Boolean,
      default: false
    },
    hidePageForOne: {
      type: Boolean,
      default: false
    },
    defaultSearchBox: {
      type: Boolean,
      default: false
    },
    defaultSearchPlaceholder: {
      default: '输入关键字搜索'
    },
    searchText: {
      type: String,
      default: ''
    },
    defaultSearchBtn: {
      type: Boolean,
      default: false
    },
    supportColumnDrag: {
      type: Boolean,
      default: false
    },
    /** 函数回调 **/
    queryDataCallBack: {
      type: Function,
      default () {
        return []
      }
    },
    beforeAddViewOpenCallback: {
      type: Function,
      default () {
        return true
      }
    },
    beforeAddViewOKCallback: {
      type: Function,
      default () {
        return true
      }
    },
    beforeAddViewCancelCallback: {
      type: Function,
      default () {
        return true
      }
    },
    beforeEditViewOpenCallback: {
      type: Function,
      default () {
        return true
      }
    },
    beforeEditViewOkCallback: {
      type: Function,
      default () {
        return true
      }
    },
    beforeEditViewCancelCallback: {
      type: Function,
      default () {
        return true
      }
    },
    searchBtnClickCallBack: {
      type: Function,
      default () {
      }
    },
    customerSearchFilter: {
      type: Function,
      default () {
        return true
      }
    },
    useDefaultFilter: {
      type: Boolean,
      default: true
    },
    deleteBtnOkClickCallBack: {
      type: Function,
      default () {
        return true
      }
    },
    useDefaultViewPage: {
      type: Boolean,
      default: false
    },
    /** 函数回调 **/
    /** 可以不设置值 **/
    size: String,
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    stripe: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    highlightRow: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: Function,
      default () {
        return ''
      }
    },
    context: {
      type: Object
    },
    noDataText: {
      type: String
    },
    noFilteredDataText: {
      type: String
    },
    disabledHover: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    },
    /**
       * @description 全局设置是否可编辑
       */
    editable: {
      type: Boolean,
      default: true
    },
    /**
       * @description 是否可搜索
       */
    searchable: {
      type: Boolean,
      default: false
    },
    /**
       * @description 搜索控件所在位置，'top' / 'bottom'
       */
    searchPlace: {
      type: String,
      default: 'top'
    },
    showTotal: {
      type: Boolean,
      default: true
    },
    showSizer: {
      type: Boolean,
      default: true
    },
    pageSizeOpts: {
      type: Array,
      default () { return [10, 20, 30, 50, 100] }
    },
    showElevator: {
      type: Boolean,
      default: true
    },
    editViewTitle: {
      type: String,
      default: '编辑'
    },
    addViewTitle: {
      type: String,
      default: '新增'
    },
    dialogWidth: {
      type: [Number, String],
      default: 520
    },
    ownHandle: {
      type: Function,
      default () {
        return true
      }
    },
    isUseOwnHandle: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    searchText (val) {
      this.searchKey = val
    },
    columns (columns) {
      this.handleColumns(columns)
    },
    rowData (val) {
      this.handleTableData()
      if (this.clientSidePage) {
        this.currentPage = 1
        this.searchKey = ''
        this.handClientSideSearch()
        this.handClientSidePageData()
        this.insideTotalCount = this.rowData.length
      }
    },
    pageIndex (val) {
      this.currentPage = val
    },
    totalCount (val) {
      if (!this.clientSidePage) {
        this.insideTotalCount = val
      }
    },
    defaultPageSize (val) {
      this.pageSize = val
    }
  },
  /**
     * Events
     * @on-start-edit 返回值 {Object} ：同iview中render函数中的params对象 { row, index, column }
     * @on-cancel-edit 返回值 {Object} 同上
     * @on-save-edit 返回值 {Object} ：除上面三个参数外，还有一个value: 修改后的数据
     */
  methods: {
    getRenderTableData () {
      if (this.clientSidePage) {
        return this.cacheTableData
      } else {
        return this.insideTableData
      }
    },
    supportEdit (item, index) {
      item.render = (h, params) => {
        return h(TablesEdit, {
          props: {
            params: params,
            value: this.insideTableData[params.index][params.column.key],
            edittingCellId: this.edittingCellId,
            editable: this.editable
          },
          on: {
            'input': val => {
              this.edittingText = val
            },
            'on-start-edit': (params) => {
              this.edittingText = params.row[params.column.key]
              this.originalEdittingText = this.edittingText
              this.edittingCellId = `editting-${params.index}-${params.column.key}`
              this.$emit('on-edit-column-start', params)
            },
            'on-cancel-edit': (params) => {
              this.edittingCellId = ''
              this.edittingText = ''
              this.originalEdittingText = ''
              this.$emit('on-edit-column-cancel', params)
            },
            'on-save-edit': (params) => {
              // 只有内容真实改变后，才会触发保存事件
              if (!(this.originalEdittingText === this.edittingText)) {
                this.insideTableData[params.index][params.column.key] = this.edittingText
                this.$emit('input', this.value)
                this.$emit('on-edit-column-save', Object.assign(params, { value: this.edittingText }))
              }
              this.originalEdittingText = ''
              this.edittingCellId = ''
              this.edittingText = ''
            }
          }
        })
      }
      return item
    },
    supportHandle (item) {
      let options = item.options || []
      let insideBtns = []
      options.forEach(item => {
        if (typeof item === 'string') {
          if (handleBtns[item]) insideBtns.push(handleBtns[item])
        } else if (typeof item === 'object') {
          // 增加权限判断
          if (this.defaultBtnPermission(item.permission)) {
            if (handleBtns[item.name]) insideBtns.push(handleBtns[item.name])
          }
        }
      })
      let addBtn = []
      if (item.button && item.button.length > 0) {
        item.button.forEach(itemBtn => {
          if (typeof itemBtn === 'function') {
            addBtn.push(itemBtn)
          } else if (typeof itemBtn === 'object') {
            if (this.defaultBtnPermission(itemBtn.permission)) {
              addBtn.push(itemBtn.render)
            }
          }
        })
      }
      let btns = [].concat(insideBtns, addBtn)
      item.render = (h, params) => {
        params.tableData = this.insideTableData
        if (!this.isUseOwnHandle) {
          return h('div', {
            on: {
              click: (e) => {
                e.stopPropagation()
              }
            }
          }, btns.map(item => item(h, params, this)))
        } else {
          return this.ownHandle(h, params, btns, this)
        }
      }
      // 没有需要渲染的按钮则不显示
      if (btns.length === 0) {
        return false
      }
      return item
    },
    handleColumns (columns) {
      this.insideColumns = []
      columns.forEach((item, index) => {
        let res = item
        if (res.editable) res = this.supportEdit(res, index)
        if (res.key === 'handle') {
          res = this.supportHandle(res)
        }
        if (res) {
          // 如果是客户端分页，并且某个列指定了排序属性，则覆盖排序属性为custom, 组件自身响应排序
          if (this.clientSidePage) {
            if (res.hasOwnProperty('sortable') && res.sortable !== false) {
              res.sortable = 'custom'
            }
          }
          this.insideColumns.push(res)
        }
      })
    },
    handleClear (e) {
      if (e.target.value === '') this.insideTableData = this.rowData
    },
    handleTableData () {
      if (this.clientSidePage) {
        this.handClientSideSearch()
        this.handClientSidePageData()
      } else {
        this.insideTableData = this.rowData.map((item, index) => {
          let res = item
          res.initRowIndex = index
          return res
        })
      }
    },
    handleClientSideSort (column, sortKey, order) {
      if (order === 'desc') {
        this.cacheTableData.sort((item1, item2) => {
          if (item1[sortKey] === undefined || item2[sortKey] === undefined) {
            if (item1[sortKey] === undefined && item2[sortKey] === undefined) {
              return 1
            } else if (item1[sortKey] === undefined && item2[sortKey] !== undefined) {
              return 1
            } else {
              return -1
            }
          } else {
            return item1[sortKey] < item2[sortKey] ? 1 : -1
          }
        })
      } else if (order === 'asc') {
        this.cacheTableData.sort((item1, item2) => {
          if (item1[sortKey] === undefined || item2[sortKey] === undefined) {
            if (item1[sortKey] === undefined && item2[sortKey] === undefined) {
              return 1
            } else if (item1[sortKey] === undefined && item2[sortKey] !== undefined) {
              return -1
            } else {
              return 1
            }
          } else {
            return item1[sortKey] > item2[sortKey] ? 1 : -1
          }
        })
      }
      this.handClientSidePageData()
    },
    handClientSidePageData () {
      this.insideTableData = []
      if (this.cacheTableData.length > 0) {
        this.insideTotalCount = this.cacheTableData.length
        let totalPage = Math.ceil(this.insideTotalCount / this.pageSize)
        if (this.currentPage > totalPage) {
          this.currentPage = totalPage
        }
        let startIndex = (this.currentPage - 1) * this.pageSize
        let endIndex = this.currentPage * this.pageSize
        if (endIndex > this.cacheTableData.length) {
          endIndex = this.cacheTableData.length
        }
        for (let i = startIndex; i < endIndex; i++) {
          this.insideTableData.push(deepCopy(this.cacheTableData[i]))
        }
      } else {
        this.insideTotalCount = 0
        this.currentPage = 1
      }
    },
    handClientSideSearch () {
      this.cacheTableData = []
      if (this.rowData.length > 0) {
        let reg = new RegExp(this.escapeHTML(this.searchKey.trim()))
        let field = ''
        for (let i = 0; i < this.rowData.length; i++) {
          if (this.useDefaultFilter) {
            if (this.customerSearchFilter(this.rowData[i], i)) {
              if (this.searchKey.trim() !== '') {
                for (let j = 0; j < this.columns.length; j++) {
                  if (this.columns[j].key !== 'handle') {
                    field = this.rowData[i][this.columns[j].key] + ''
                    if ((field).match(reg)) {
                      this.cacheTableData.push(deepCopy(this.rowData[i]))
                      break
                    }
                  }
                }
              } else {
                this.cacheTableData.push(deepCopy(this.rowData[i]))
              }
            }
          } else {
            if (this.customerSearchFilter(this.rowData[i], i)) {
              this.cacheTableData.push(deepCopy(this.rowData[i]))
            }
          }
        }
      }
    },
    escapeHTML (text) {
      if (typeof text === 'string') {
        return text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;')
          .replace(/`/g, '&#x60;')
      }
      return text
    },
    onCurrentChange (currentRow, oldCurrentRow) {
      this.$emit('on-current-change', currentRow, oldCurrentRow)
    },
    onSelect (selection, row) {
      this.$emit('on-select', selection, row)
    },
    onSelectCancel (selection, row) {
      this.$emit('on-select-cancel', selection, row)
    },
    onSelectAll (selection) {
      this.$emit('on-select-all', selection)
    },
    onSelectionChange (selection) {
      this.$emit('on-selection-change', selection)
    },
    onSortChange (sortData) {
      if (!this.clientSidePage) {
        this.$emit('on-sort-change', sortData)
      } else {
        this.handleClientSideSort(sortData.column, sortData.key, sortData.order)
      }
    },
    onFilterChange (row) {
      this.$emit('on-filter-change', row)
    },
    onRowClick (row, index) {
      this.$emit('on-row-click', row, index)
    },
    onRowDblclick (row, index) {
      this.$emit('on-row-dblclick', row, index)
    },
    onExpand (row, status) {
      this.$emit('on-expand', row, status)
    },
    changePage (selectPageIndex) {
      this.currentPage = selectPageIndex
      if (this.clientSidePage) {
        this.handClientSidePageData()
      } else {
        this.queryDataCallBack(this.currentPage, this.pageSize)
      }
      this.$emit('on-change-page', selectPageIndex)
    },
    changePageSize (pageSize) {
      console.info('changePageSize', pageSize)
      this.pageSize = pageSize
      let allPage = Math.ceil(this.insideTotalCount / this.pageSize)
      let totalPage = (allPage === 0) ? 1 : allPage
      if (this.currentPage > totalPage) {
        this.currentPage = totalPage
      }
      if (this.clientSidePage) {
        this.handClientSidePageData()
      } else {
        this.queryDataCallBack(this.currentPage, this.pageSize)
      }
    },
    /** 点击编辑按钮事件 **/
    onEditBtnClick (item) {
      this.beforeEditViewOpenCallback(item.tableData[item.index])
      this.editViewMode = true
      this.editFormLoading = false
    },
    onEditViewBtnOk () {
      // 点击Ok前回调
      this.beforeEditViewOkCallback()
    },
    onEditViewBtnCancel () {
      if (this.beforeEditViewCancelCallback()) {
        this.editViewMode = false
      }
    },
    onAddBtnClick () {
      if (this.beforeAddViewOpenCallback()) {
        this.addViewMode = true
        this.addFormLoading = false
      }
    },
    onAddViewBtnOk () {
      this.beforeAddViewOKCallback()
    },
    onAddViewBtnCancel () {
      this.addFormLoading = false
      this.beforeAddViewCancelCallback()
    },
    onAddItemStart (data) {
      this.addFormLoading = true
    },
    saveAddItemSuccess (result) {
      this.addFormLoading = false
      if (result) {
        this.addViewMode = false
        this.queryDataCallBack()
      }
    },
    onEditItemStart (data) {
      this.editFormLoading = true
    },
    saveEditItemSuccess (result) {
      this.editFormLoading = false
      if (result) {
        this.editViewMode = false
        this.queryDataCallBack()
      }
    },
    onSearchBtnClick (event) {
      this.searchBtnClickCallBack(this.searchKey)
      if (this.clientSidePage) {
        this.handClientSideSearch()
        this.handClientSidePageData()
      } else {
        this.queryDataCallBack()
      }
    },
    onRowsView (item) {
      if (this.useDefaultViewPage) {
        this.$Modal.info({
          title: 'User Info',
          content: `
           <ul>
           <li v-for="column in this.columns" >
                121232
          </li>
        </ul>
        <p>${this.rowData[item.index]['id']}</p>
        <p>${this.rowData[item.index].title}</p>
        `
        })
      }
    },
    startFunc (e) {
      this.$emit('on-start', this.insideTableData[e.oldIndex])
    },
    endFunc (e) {
      this.$emit('on-end', {
        from: this.insideTableData[e.oldIndex],
        to: this.insideTableData[e.newIndex]
      })
    },
    chooseFunc (e) {
      this.$emit('on-choose', this.insideTableData[e.oldIndex])
    }
  },
  mounted () {
    this.pageSize = this.defaultPageSize
    this.handleColumns(this.columns)
    this.handleTableData()
    if (this.supportColumnDrag) {
      let el = this.$refs.dragable.$children[1].$el.children[1]
      let vm = this
      Sortable.create(el, {
        onStart: vm.startFunc,
        onEnd: vm.endFunc,
        onChoose: vm.chooseFunc
      })
    }
  }
}
</script>

<style scoped lang="less">
.table-toolbar {
  margin-bottom: 5px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  &:before {
    display: none;
  }
  &:after {
    display: none;
  }
}
.table-toolbar-left {
  margin-left: 2px;
}
.table-toolbar-right {
  margin-right: 2px;
}

.horizontal-layout {
  display:flex;
  display:-webkit-flex; /* Safari */
  flex-flow:row;
}
</style>
